<script>
    export let href = "#";
    export let title = "";
</script>

<a
    href="{href}"
    title="{title}"
    class="p-3 rounded-full bg-white border hover:bg-sky-700 hover:text-white"
>
      <slot />
</a>
